import React from "react";
import ReactApexChart from "react-apexcharts";
import useWindowDimensions, { humanReadable } from "../../utils/useWindowDimensions";

const PopEnv = ({ data, Dashboard = "user" }) => {
  let { width } = useWindowDimensions();

  let count = [];
  let envName = [];
  for (var i = 0; i < data.length; i++) {
    envName.push(data[i].name);
    count.push(i + 1);
  }

  let envLabels = data.map((elem) => {
    let name = elem.name
      .split(" ")
      .map((e) => e[0])
      .join("");
    if (name.length === 1) {
      return (name = elem.name.split(" ")[0].substring(0, 6));
    }
    return name;
  });

  const chartData = {
    series: [
      {
        name: "Visit",
        type: "bar",
        data: data.map((e) => e.visit),
      },
      {
        name: "Time Spent(In hours)",
        type: "bar",
        data: data.map((e) => humanReadable(e.totalTime)),
      },
    ],
    options: {
      chart: {
        type: "bar",
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          columnWidth: "25%",
          borderRadius: 3,
          borderWidth: 1,
        },
      },
      colors: ["#CA353B", "#333333"],
      stroke: {
        show: true,
        width: 1,
        colors: ["transparent"],
      },
      fill: {
        type: "solid",
      },
      labels: envLabels,
      markers: {
        size: 0,
      },
      yaxis: [
        {
          title: {
            text: "Visits",
          },
        },
        {
          opposite: true,
          title: {
            text: "Hours",
          },
          labels: {
            formatter: function (value) {
              return Math.round(value);
            },
          },
        },
      ],
      tooltip: {
        enabled: true,
        shared: false,
        followCursor: true,
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          if (seriesIndex === 0) {
            return (
              '<div class="custom-tooltip p-2">' +
              "<span>" +
              envName[dataPointIndex] +
              "<br/>" +
              series[seriesIndex][dataPointIndex] +
              " Visits</span>" +
              "</div>"
            );
          } else if (seriesIndex === 1) {
            return (
              '<div class="custom-tooltip p-2">' +
              "<span>" +
              envName[dataPointIndex] +
              "<br/>" +
              series[seriesIndex][dataPointIndex] +
              " Hours</span>" +
              "</div>"
            );
          }
        },
      },
      legend: {
        offsetY: 10,
        horizontalAlign: "left",
      },
    },
  };

  return (
    <div id="chart">
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={
          Dashboard === "team"
            ? width > 1400 && width < 1700
              ? 235
              : width >= 1700
              ? 280
              : 185
            : width > 1400 && width < 1700
            ? 235
            : width >= 1700
            ? 300
            : 185
        }
      />
    </div>
  );
};

export default PopEnv;
